export let OrderChoicesEnum = /*#__PURE__*/function (OrderChoicesEnum) {
  OrderChoicesEnum["UpdatedAt"] = "updated_at";
  OrderChoicesEnum["UpdatedAtDescending"] = "-updated_at";
  OrderChoicesEnum["CreatedAt"] = "created_at";
  OrderChoicesEnum["CreatedAtDescending"] = "-created_at";
  OrderChoicesEnum["SubmittedAt"] = "submitted_at";
  OrderChoicesEnum["SubmittedAtDescending"] = "-submitted_at";
  OrderChoicesEnum["DueDate"] = "due_date";
  OrderChoicesEnum["DueDateDescending"] = "-due_date";
  OrderChoicesEnum["Name"] = "name";
  OrderChoicesEnum["NameDescending"] = "-name";
  OrderChoicesEnum["ProjectName"] = "project_name";
  OrderChoicesEnum["ProjectNameDescending"] = "-project_name";
  return OrderChoicesEnum;
}({});